import React from 'react'
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ComingSoon from './ComingSoon';
import PremiumMembership from './PremiumMembership';

const App = () => {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ComingSoon />} />
          <Route path="/premium-membership" element={<PremiumMembership />} />
        </Routes>
      </BrowserRouter>
    </>
  )
}

export default App